import { createSlice } from '@reduxjs/toolkit';
import { werdAlthekr} from './allAthkar';
import { numDecreaseAct, prograssNum, showInfoAct } from './actions';

export const setRepeatForAll = (state, action) => {
  const newValue = Number(action.payload);

  state.data.forEach((thekr) => {
    thekr.repeat = newValue;
  });

  state.value = 0; // نرجع البروجرس صفر لما نغير العدد
};


const werdAlthekrSlice = createSlice({
  name: 'werdAlthekr',
  initialState: werdAlthekr,
  reducers: {
    showInfoW: showInfoAct,
    numDecreaseW: numDecreaseAct,
    prograssNumW:prograssNum,
    setRepeatForAllW: setRepeatForAll

  },
});


export const { showInfoW, numDecreaseW,prograssNumW,setRepeatForAllW  } = werdAlthekrSlice.actions;
export default werdAlthekrSlice.reducer;